import { ShieldCheck, Search, Cpu, Lock } from "lucide-react";
import { SectionHeading, Reveal } from "./shared";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Bancada Segura e Organizada",
    desc: "Seu aparelho é aberto em ambiente protegido contra eletricidade estática, com cuidado do início ao fim.",
  },
  {
    icon: Search,
    title: "Diagnóstico de Verdade",
    desc: "Encontramos o defeito real com equipamentos de precisão, sem chute e sem troca de peça desnecessária.",
  },
  {
    icon: Cpu,
    title: "Reparo de Placa Especializado",
    desc: "Reparamos apenas o componente com defeito, sem precisar trocar a placa inteira — o conserto fica muito mais em conta.",
  },
  {
    icon: Lock,
    title: "Seus Dados Intocados",
    desc: "Privacidade total das suas fotos, conversas e senhas durante todo o reparo.",
  },
];

export default function WhyUs() {
  return (
    <section id="diferenciais" className="relative py-24 sm:py-32 px-4 sm:px-8 bg-[#293138]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <SectionHeading
            overline="/// Por que a Pressi"
            title="POR QUE A PRESSI NÃO É UMA ASSISTÊNCIA COMUM"
          />
          <div className="mt-10 space-y-6">
            {PILLARS.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08}>
                <div className="flex gap-5 group">
                  <div className="shrink-0 w-12 h-12 rounded-xl border border-[#99BA4B]/40 bg-[#99BA4B]/10 flex items-center justify-center group-hover:bg-[#99BA4B]/20 transition-colors duration-300">
                    <p.icon size={22} className="text-[#99BA4B]" />
                  </div>
                  <div>
                    <h3 className="font-display text-lg text-white">{p.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-zinc-300">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15} className="relative">
          <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
            <img
              src="/loja-pressi.jpg"
              alt="Fachada da loja física da Pressi Celulares na Av. São Borja, São Leopoldo"
              loading="lazy"
              className="w-full aspect-[4/5] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#252D33]/90 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center border border-white/15 bg-black/50 backdrop-blur-md rounded-xl px-4 py-3">
              <span className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-zinc-200">
                Loja física na Av. São Borja em São Leopoldo/RS
              </span>
            </div>
          </div>
          <div className="absolute -top-4 -right-4 font-mono-tech text-[10px] tracking-[0.25em] text-[#ADCF5D] border border-[#99BA4B]/50 bg-[#252D33] px-3 py-2 rounded-lg rotate-3">
            CUIDADO EM CADA DETALHE
          </div>
        </Reveal>
      </div>
    </section>
  );
}
